import ItemsV3Serializer from '@square/dashboard-items-data/serializers/items-v3-base';
export default ItemsV3Serializer.extend({
  attrs: {
    items: {
      serialize: 'ids',
      deserialize: 'ids'
    }
  },
  keyForRelationship(key, type) {
    if (key === 'tax') {
      return 'fee_id';
    } else if (key === 'diningOptions') {
      return 'dining_option_id';
    } else if (key === 'items') {
      return 'item_id';
    }
    return this._super(key, type);
  }
});